import axios from "axios";
import { FETCH_QUIZ_WITH_ANSWERS, FETCH_BREED_QUIZ_FEATURES, CREATE_BREED_QUIZ_FEATURES, QUIZ_FEATURES_VIA_BREED, FETCH_AVAILABLE_QUIZ_BREED, EDIT_BREED_QUIZ_FEATURES, DELETE_BREED_QUIZ_FEATURES, CREATE_BREED_QUIZ_FEATURES_FROM_FILE, UPDATE_QUIZ,
  FETCH_AVAILABLE_PUPPIES_BASE_ON_QUIZ_ANSWERS, interceptor } from ".";
import store from "../store";

interceptor(axios, store);

export function fetchQuizes(data) {
  return {
    type: FETCH_QUIZ_WITH_ANSWERS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/quiz/${data.startDate}/${data.endDate}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function updateQuiz(id,data){
  return {
    type: UPDATE_QUIZ,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/quiz/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function fetchBreedQuizFeatures() {
  return {
    type: FETCH_BREED_QUIZ_FEATURES,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/quiz/getBreedQuizFeatures`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function createBreedQuizFeatures(features) {
  return {
    type: CREATE_BREED_QUIZ_FEATURES,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/quiz/createBreedQuizFeatures`,features, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function createBreedQuizFeaturesFromFile(features) {
  return {
    type: CREATE_BREED_QUIZ_FEATURES_FROM_FILE,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/quiz/createBreedQuizFeatures/fromFile`,features, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function getQuizFeaturesViaBreed() {
  return {
    type: QUIZ_FEATURES_VIA_BREED,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/quiz/quizFeatures`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function getAvailableQuizBreeds() {
  return {
    type: FETCH_AVAILABLE_QUIZ_BREED,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/quiz/availableBreeds`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function editBreedQuizFeatures(id,data) {
  return {
    type:  EDIT_BREED_QUIZ_FEATURES,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/quiz/editBreedQuizFeature/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function deleteBreedQuizFeatures(id) {
  return {
    type:  DELETE_BREED_QUIZ_FEATURES,
    payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/quiz/deleteBreedQuizFeature/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}


export function getAvailablePuppiesBaseOnQuizAnswers(quizUserData) {
  return {
    type: FETCH_AVAILABLE_PUPPIES_BASE_ON_QUIZ_ANSWERS,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/quiz/userAnswers/availablePuppies`,quizUserData, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

